<app-visum-form *ngIf="isEverythingPreloaded()"></app-visum-form>

<div *ngIf="errorCodes.length > 0">
  <app-error [errorCodes] = errorCodes></app-error>
</div>
